module.exports = __webpack_public_path__ + "img/para_instalar_azulejos.8bf0a71b.png";